module.exports = __webpack_public_path__ + "static/media/Lateral_NES_Z2.3e3f838d.png";